const normaliseDateList = (dates) => (
  Array.isArray(dates)
    ? dates.filter(Boolean).map((date) => String(date))
    : []
)

const uniqueSortedDates = (dates) => [...new Set(dates)].sort()

export const disabledDatesForProduct = (attraction = {}, productCode = '') => {
  const globalDates = normaliseDateList(attraction?.disabled_dates)
  const selectedProductCode = productCode ? String(productCode) : ''
  const datesByProduct = attraction?.disabled_dates_by_product

  if (!selectedProductCode || !datesByProduct || Array.isArray(datesByProduct) || typeof datesByProduct !== 'object') {
    return globalDates
  }

  return uniqueSortedDates([
    ...globalDates,
    ...normaliseDateList(datesByProduct[selectedProductCode]),
  ])
}

export const isDateDisabledForProduct = (attraction = {}, productCode = '', date = '') => (
  disabledDatesForProduct(attraction, productCode).includes(String(date))
)
